import React from 'react';
import { publish } from '@conversion-cloud-widget/pubsub';
import { CloseButton } from '@conversion-cloud-widget/UI';

const ModuleBarHeader = ({ backgroundColor, heading, subheading, textColor }) => {

    const handleClose = () => {
        const moduleBar = document.querySelector('#clx-container__module-bar');
        moduleBar.setAttribute('style', '');
        moduleBar.classList.remove('opened');

        publish('WALLET_MORE_CLOSE', {});
    };

    return (
        <div className="clx-container__module-bar__header" style={{backgroundColor: backgroundColor, color: textColor}}>
            <div className="clx-container__module-bar__header-close">
                <CloseButton fill={textColor} onClick={handleClose} />
            </div>
            <div>
                <h1 className="clx-container__module-bar__header-title">{heading}</h1>
                <p className="clx-container__module-bar__header-text">
                    {subheading}
                </p>
            </div>
        </div>
    );
};

export default ModuleBarHeader;